"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Pagination = _interopRequireDefault(require("./Pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(_default, _PureComponent);

  function _default(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      current: props.current || props.defaultCurrent,
      pageSize: props.pageSize
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = _default.prototype;

  _proto.handleChange = function handleChange(current, pageSize) {
    if (pageSize === void 0) {
      pageSize = this.state.pageSize;
    }

    var sizeChange = pageSize !== this.state.pageSize;
    this.setState({
      current: current,
      pageSize: pageSize
    });

    if (this.props.onChange) {
      this.props.onChange(current, pageSize, sizeChange);
    }
  };

  _proto.render = function render() {
    var current = this.props.current || this.state.current;
    if (this.props.total < 0) return null;
    return _react.default.createElement(_Pagination.default, _extends({}, this.props, {
      current: current,
      pageSize: this.state.pageSize,
      onChange: this.handleChange
    }));
  };

  return _default;
}(_react.PureComponent);

exports.default = _default;

_defineProperty(_default, "displayName", 'ShineoutPagination');

_defineProperty(_default, "propTypes", {
  current: _propTypes.default.number,
  defaultCurrent: _propTypes.default.number,
  onChange: _propTypes.default.func,
  pageSize: _propTypes.default.number,
  total: _propTypes.default.number
});

_defineProperty(_default, "defaultProps", {
  defaultCurrent: 1,
  pageSize: 10,
  total: 0
});